import React, { useEffect, useState } from 'react';
import { salesPageData } from '../data/salesPageData';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-[#D89A3D]/25 bg-[#111111]/97 px-3 py-3 backdrop-blur-md transition-transform duration-300 md:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-372" data-mp="w43vsgi45zgy">
      <a href="#oferta" className="flex min-h-[52px] w-full items-center justify-center gap-2 rounded-lg bg-[#FF7A00] px-4 font-display text-sm font-extrabold uppercase tracking-wide text-[#111111] transition-colors hover:bg-[#E96800]" data-id="element-373" data-mp="15znoyv5amk20">
        Ver oferta — {salesPageData.promotionalPrice}
      </a>
    </div>;
}